/**
 * @Name: 酒店资源配置 store
 */
import services from '../../services'
import devConfig from '@/config/index'
import { __replaceDotCom } from '@/utils/tools'
let hostUrl = devConfig.gateway.MsaGatewayAddress
hostUrl = __replaceDotCom(hostUrl, true)
const state = {
    itravelHotelPagedList: [],
    rspHotelPageList: [], // 新增酒店配置-资源库酒店列表
    pageVOHotelPageList: {
        curPage: 1,
        pageSize: 10,
        totalRows: 0
    },
    pageVORspHotelPageList: {
        curPage: 1,
        pageSize: 10,
        totalRows: 0
    },
    businessTypeMap: { // 业务类型映射，公司：1  个人：2  商旅：3
        company: '1',
        individual: '2',
        business: '3'
    },
    whetherToBookList: [], // 是否可预订列表
    windowTypeList: [], // 窗型列表
    internetTypeList: [], // 上网方式列表
    itravelHotelDetailList: null,
    hotelImg: require('@/assets/images/bitmap_hotel.jpg'),
    hotelImgEn: require('@/assets/images/bitmap_hotel_en.jpg'),
    resouceTypeList: [],
    isEnableList: [],
    starLevelList: [],
    starLevelListCommon: [],
    confeienceStarLevelList: [], // 资源库酒店星级
    itravelStarLevelList: [], // 差旅酒店星级
    hotelFeaturensList: [], // 爱上会酒店特点
    levelList: [], // 客户级别
    brandList: [], // 酒店品牌
    locationList: [], // 位置信息
    hotelPageVO: {
        curPage: 1,
        pageSize: 10,
        totalRows: 0
    },
    hotelResourcesList: [], // 酒店资源列表
    roomTypeDetailList: [], // 酒店详情-房型信息 列表数据
    roomTypeDetailListPageVo: { // 酒店详情-房型信息 分页
        curPage: 1,
        pageSize: 10,
        totalRows: 0
    },
    roomNumDetailList: [], // 酒店详情-房量信息 列表数据
    roomNumDetailListPageVo: { // 酒店详情-房量信息 分页
        curPage: 1,
        pageSize: 10,
        totalRows: 0
    },
    downloadTemplateUrl: `${hostUrl}com.huawei.it.mbs.eventsgo:eventsgomedia/eventsgo/media/servlet/download`
}

const getters = {
}
const actions = {

    /**
     * 设置酒店是否启用
     * @param {*} context
     * @param {*} param
     */
    setHotelIsEnable(context, param) {
        return new Promise((resolve, reject) => {
            services.hotelConfigSer.setHotelIsEnable(param).then((res) => {
                resolve(res.data || {})
            })
        })
    },

    /**
     * 获取酒店资源列表数据
     * @param {*} context
     * @param {*} param
     */
    getHotelResourcesList(context, param) {
        return new Promise((resolve, reject) => {
            services.hotelConfigSer.getHotelResourcesList(param).then((res) => {
                context.commit('setHotelResourcesList', res.data || {})
                resolve()
            })
        })
    },

    /**
     * 设置酒店是否推荐
     * @param {*} context
     * @param {*} param
     */
    setHotelIsHot(context, param) {
        return new Promise((resolve, reject) => {
            services.hotelConfigSer.setHotelIsHot(param).then((res) => {
                resolve(res.data || {})
            })
        })
    },

    /**
     * 删除酒店资源数据
     * @param {*} context
     * @param {*} param
     */
    deleteHotelResourcesData(context, param) {
        return new Promise((resolve, reject) => {
            services.hotelConfigSer.deleteHotelResourcesData(param).then((res) => {
                resolve(res.data || {})
            })
        })
    },

    /**
     * 获取房型列表数据
     * @param {*} context
     * @param {*} param
     */
    getRoomTypeListData(context, param) {
        return new Promise((resolve, reject) => {
            services.hotelConfigSer.getRoomTypeListData(param).then((res) => {
                resolve(res.data || {})
            })
        })
    },

    /**
     * 获取差旅房型数据
     * @param {*} context
     * @param {*} param
     */
    getItravelRoomTypeData(context, param) {
        return new Promise((resolve, reject) => {
            services.hotelConfigSer.getItravelRoomTypeData(param).then((res) => {
                resolve(res.data || {})
            })
        })
    },

    /**
     * 导出酒店资源列表数据
     * @param {*} context
     * @param {*} param
     */
    exportHotelResourcesData(context, param) {
        return new Promise((resolve, reject) => {
            services.hotelConfigSer.exportHotelResourcesData(param).then((res) => {
                resolve(res.data || {})
            })
        })
    },

    /**
     * 导出房型房量数据
     * @param {*} context
     * @param {*} param
     */
    exportRoomData(context, param) {
        return new Promise((resolve, reject) => {
            services.hotelConfigSer.exportRoomData(param).then((res) => {
                resolve(res.data || {})
            })
        })
    },

    /**
     * 导入房型房量数据
     * @param {*} context
     * @param {*} param
     */
    importRoomData(context, param) {
        return new Promise((resolve, reject) => {
            services.hotelConfigSer.importRoomData(param).then((res) => {
                resolve(res.data || {})
            })
        })
    },

    /**
     * 获取房型详情的数据
     * @param {*} context
     * @param {*} param
     */
    getRoomDetailData(context, param) {
        return new Promise((resolve, reject) => {
            services.hotelConfigSer.getRoomDetailData(param).then((res) => {
                resolve(res.data || {})
            })
        })
    },

    /**
     * 新增房型数据
     * @param {*} context
     * @param {*} param
     */
    addRoomTypeData(context, param) {
        return new Promise((resolve, reject) => {
            services.hotelConfigSer.addRoomTypeData(param).then((res) => {
                resolve(res.data || {})
            }).catch(error => {
                reject(error)
            })
        })
    },

    /**
     * 编辑房型数据
     * @param {*} context
     * @param {*} param
     */
    modifyRoomTypeData(context, param) {
        return new Promise((resolve, reject) => {
            services.hotelConfigSer.modifyRoomTypeData(param).then((res) => {
                resolve(res.data || {})
            }).catch(error => {
                reject(error)
            })
        })
    },

    /**
     * 删除房型数据
     * @param {*} context
     * @param {*} param
     */
    deleteRoomTypeData(context, param) {
        return new Promise((resolve, reject) => {
            services.hotelConfigSer.deleteRoomTypeData(param).then((res) => {
                resolve(res.data || {})
            })
        })
    },

    /**
     * 获取房量列表数据
     * @param {*} context
     * @param {*} param
     */
    getRoomQuantityListData(context, param) {
        return new Promise((resolve, reject) => {
            services.hotelConfigSer.getRoomQuantityListData(param).then((res) => {
                resolve(res.data || {})
            })
        })
    },

    /**
     * 校验房量数据
     * @param {*} context
     * @param {*} param
     */
    checkOrderHotelRoomVolumeAct(context, param) {
        return new Promise((resolve, reject) => {
            services.hotelConfigSer.checkOrderHotelRoomVolumeSer(param).then((res) => {
                resolve(res.data || {})
            }).catch(error => {
                reject(error)
            })
        })
    },

    /**
     * 保存房量数据
     * @param {*} context
     * @param {*} param
     */
    saveRoomQuantityData(context, param) {
        return new Promise((resolve, reject) => {
            services.hotelConfigSer.saveRoomQuantityData(param).then((res) => {
                resolve(res.data || {})
            }).catch(error => {
                reject(error)
            })
        })
    },

    /**
     * 获取酒店相关数据字典配置数据
     * @param {*} context
     * @param {*} param
     */
    getHotelLookupData(context, param) {
        return new Promise((resolve, reject) => {
            services.hotelConfigSer.getHotelLookupData(param).then((res) => {
                resolve(res)
            })
        })
    },

    /**
     * 获取酒店相关数据字典配置数据：爱上会
     * @param {*} context
     * @param {*} param
     */
    getHotelLookupForCommon(context, param) {
        return new Promise((resolve, reject) => {
            services.hotelConfigSer.getHotelLookupForCommon(param).then((res) => {
                resolve(res)
            })
        })
    },

    /**
     * 上传图片
     * @param {*} context
     * @param {*} param
     */
    uploadImage(context, param) {
        return new Promise((resolve, reject) => {
            services.hotelConfigSer.uploadImage(param.formData, param.stparams).then((res) => {
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        })
    },

    /**
     * 获取酒店详情 - 酒店基本数据
     * @param {*} context
     * @param {*} param
     */
    findConfigHotelDetails(context, param) {
        return new Promise((resolve, reject) => {
            services.hotelConfigSer.findConfigHotelDetails(param).then((res) => {
                resolve(res.data || {})
            })
        })
    },

    /**
     * 获取酒店详情 - 房型列表数据
     * @param {*} context
     * @param {*} param
     */
    getDetailRoomTypeListData(context, param) {
        return new Promise((resolve, reject) => {
            services.hotelConfigSer.getDetailRoomTypeListData(param).then((res) => {
                context.commit('setDetailRoomTypeListData', res.data || {})
                resolve(res.data || {})
            })
        })
    },

    /**
     * 获取酒店详情 - 房量列表数据
     * @param {*} context
     * @param {*} param
     */
    getDetailRoomNumListData(context, param) {
        return new Promise((resolve, reject) => {
            services.hotelConfigSer.getDetailRoomNumListData(param).then((res) => {
                context.commit('setDetailRoomNumListData', res.data || {})
                resolve(res.data || {})
            })
        })
    },

    /**
     * 获取酒店详情 - 房量列表数据统计(表头的合计)
     * @param {*} context
     * @param {*} param
     */
    getDetailRoomNumCount(context, param) {
        return new Promise((resolve, reject) => {
            services.hotelConfigSer.getDetailRoomNumCount(param).then((res) => {
                resolve(res.data || {})
            })
        })
    },

    /**
     * 获取酒店详情 - 房量信息 - 酒店所配置的房型列表数据
     * @param {*} context
     * @param {*} param
     */
    findRoomTypeNamesList(context, param) {
        return new Promise((resolve, reject) => {
            services.hotelConfigSer.findRoomTypeNamesList(param).then((res) => {
                resolve(res.data || {})
            })
        })
    },

    /**
     * 获取酒店详情 - 酒店概况
     * @param {*} context
     * @param {*} param
     */
    findHotelOverview(context, param) {
        return new Promise((resolve, reject) => {
            services.hotelConfigSer.findHotelOverview(param).then((res) => {
                resolve(res.data || {})
            })
        })
    },

    /**
     * 获取隐私声明 - 隐私详情
     * @param {*} context
     * @param {*} param
     */
    getPrivacyStatement(context, param) {
        return new Promise((resolve, reject) => {
            services.hotelConfigSer.getPrivacyStatement().then((res) => {
                resolve(res.data || {})
            })
        })
    },

    /** ============================= 新增酒店 ============================= **/
    /**
     * 新增酒店差旅信息
     */
    findItravelHotelPagedList(context, param) {
        return new Promise((resolve, reject) => {
            services.hotelConfigSer.findItravelHotelPagedList(param).then((res) => {
                context.commit('setItravelHotelPagedList', res.data || {})
                resolve(res.data || {})
            })
        })
    },

    /**
     * 新增酒店差旅详情信息
     */
    findItravelHotelDetail(context, param) {
        return new Promise((resolve, reject) => {
            services.hotelConfigSer.findItravelHotelDetail(param).then((res) => {
                resolve(res.data || {})
            })
        })
    },

    /**
     * 资源库详情数据
     */
    findzykHotelDetail(context, param) {
        return new Promise((resolve, reject) => {
            services.hotelConfigSer.findzykHotelDetail(param).then((res) => {
                resolve(res.data || {})
            })
        })
    },

    /**
     * 新增酒店-资源库酒店列表
     */
    findRspHotelPageList(context, param) {
        return new Promise((resolve, reject) => {
            services.hotelConfigSer.findRspHotelPageList(param).then((res) => {
                context.commit('setRspHotelPageList', res.data || {})
                resolve(res)
            })
        })
    },

    /**
     * 新增保存接口
     */
    findAddHotel(context, param) {
        return new Promise((resolve, reject) => {
            services.hotelConfigSer.findAddHotel(param).then((res) => {
                resolve(res)
            })
        })
    },

    /**
     * 编辑接口
     */
    findSaveHotel(context, param) {
        return new Promise((resolve, reject) => {
            services.hotelConfigSer.findSaveHotel(param).then((res) => {
                resolve(res)
            })
        })
    },
    findPerson(context, param) {
        return new Promise((resolve, reject) => {
            services.hotelConfigSer.findPerson(param).then((res) => {
                resolve(res.data)
            })
        })
    },
    getPubilcCommon(context, param) {
        return new Promise((resolve, reject) => {
            services.hotelConfigSer.getPubilcCommon(param).then((res) => {
                resolve(res)
            })
        })
    },
    getLocationCommon(context, param) {
        return new Promise((resolve, reject) => {
            services.hotelConfigSer.getLocationCommon(param).then((res) => {
                resolve(res)
            })
        })
    }

    /** ============================= 新增酒店 ============================= **/
}
const mutations = {

    /**
     * 设置酒店资源列表数据
     * @param {*} state
     * @param {*} payload
     */
    setHotelResourcesList(state, payload) {
        let data = payload.data || []
        data.forEach((item, index) => {
            item.expand = false
            item.isEdit = false
            item.rowIndex = index
            item.roomTypeList = []
        })
        state.hotelResourcesList = data
        state.hotelPageVO = payload.pageInfo
    },

    /**
     * 设置酒店资源列表分页数据
     * @param {*} state
     * @param {*} payload
     */
    setHotelPageVO(state, payload) {
        Object.keys(payload).forEach(key => {
            state.hotelPageVO[key] = payload[key]
        })
    },

    /**
     * 设置资源来源数据
     * @param {*} state
     * @param {*} payload
     */
    setResouceTypeData(state, payload) {
        state.resouceTypeList = payload
    },

    /**
     * 设置是否启用数据
     * @param {*} state
     * @param {*} payload
     */
    setIsEnableData(state, payload) {
        state.isEnableList = payload
    },

    /**
     * 设置酒店星级数据
     * @param {*} state
     * @param {*} payload
     */
    setStarLevelData(state, payload) {
        state.starLevelList = payload
    },

    /**
     * 设置窗型数据
     * @param {*} state
     * @param {*} payload
     */
    setWindowTypeList(state, payload) {
        state.windowTypeList = payload
    },

    /**
     * 设置上网方式数据
     * @param {*} state
     * @param {*} payload
     */
    setInternetTypeList(state, payload) {
        state.internetTypeList = payload
    },

    /**
     * 设置是否可预订数据
     * @param {*} state
     * @param {*} payload
     */
    setWhetherToBookList(state, payload) {
        state.whetherToBookList = payload
    },

    /**
     * 设置酒店星级数据：爱上会
     * @param {*} state
     * @param {*} payload
     */
    setStarLevelDataCommon(state, payload) {
        state.starLevelListCommon = payload
    },
    setItravelStarLevelData(state, payload) {
        state.itravelStarLevelList = payload
    },

    /**
     * 酒店详情-房型列表
     */
    setDetailRoomTypeListData(state, payload) {
        payload.data && (state.roomTypeDetailList = payload.data)
        payload.pageInfo && (state.roomTypeDetailListPageVo = payload.pageInfo)
    },

    /**
     * 酒店详情-房量列表
     */
    setDetailRoomNumListData(state, payload) {
        state.roomNumDetailList = payload.data
        state.roomNumDetailListPageVo = payload.pageInfo
    },

    /** ============================= 新增酒店 ============================= **/
    /**
     * 设置资源库过来的酒店数据
     * @param {*} state
     * @param {*} payload
     */
    setConfeienceStarLevelData(state, payload) {
        state.confeienceStarLevelList = payload
    },
    setItravelHotelPagedList(state, payload) {
        payload.data && (state.itravelHotelPagedList = payload.data)
        payload.pageInfo && (state.pageVOHotelPageList = payload.pageInfo)
    },

    /**
     * 新增酒店差旅酒店详情
     */
    setItravelHotelDetail(state, payload) {
        state.itravelHotelDetailList = payload
    },

    /**
     * 酒店特点lockup
     */
    setHotelFeaturesData(state, payload) {
        state.hotelFeaturensList = payload
    },

    /**
     * 客户级别
     */
    setPublicCommon(state, payload) {
        state.levelList = payload
    },

    /**
     * 新增酒店-资源库酒店列表
     */
    setRspHotelPageList(state, payload) {
        payload.data && (state.rspHotelPageList = payload.data)
        payload.pageInfo && (state.pageVORspHotelPageList = payload.pageInfo)
    },

    /**
     * 酒店品牌
     */
    setbrandData(state, payload) {
        state.brandList = payload
    },
    setLocationData(state, payload) {
        state.locationList = payload
    }

    /** ============================= 新增酒店 ============================= **/
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
